import React from 'react'
import {Button} from '../Button/Button'
import './Confirm.css'

export interface ConfirmProps {
    message?: string
    buttons?: string[]
    onClick?: Function
    top?: number
}

export class Confirm extends React.Component<ConfirmProps, {}> {
    render() {
        const {buttons, message, top} = this.props

        return (
            <div
                className={'Confirm ' + (message ? 'Confirm_opened' : '')}
                style={top !== undefined ? {top: top + 'px'} : {}}
            >
                <div className="Confirm-message">{message}</div>
                <div className="Confirm-button-w">
                    {(buttons || ['Ok']).map((text, index) => (
                        <Button className="Confirm-button" onClick={() => this.onClick(index)} key={index}>
                            {text}
                        </Button>
                    ))}
                </div>
            </div>
        )
    }

    private onClick(index: number): void {
        if (this.props.onClick) {
            this.props.onClick(index)
        }
    }
}
